import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const config = {
    apiKey: "AIzaSyAqA47grrvUhi5_cK64xG6tiP_5nLArsZk",
    authDomain: "soemp-b1520.firebaseapp.com",
    databaseURL: "https://soemp-b1520.firebaseio.com",
    projectId: "soemp-b1520",
    storageBucket: "soemp-b1520.appspot.com",
    messagingSenderId: "708668762331"
};
const app = firebase.initializeApp(config);

export default class FirebaseService {

    static getApp() {
        return app;
    }

}